import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const AjouterDemandeLogiciel = () => {
  const [descriptionBesoin, setDescriptionBesoin] = useState('');
  const [localite, setLocalite] = useState('');
  const [nomCompagnie, setNomCompagnie] = useState('');
  const [adresseEmail, setAdresseEmail] = useState('');
  const [numeroTel, setNumeroTel] = useState('');
  const [images, setImages] = useState([]); // Stocker les fichiers réels
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // ID client récupéré automatiquement (par exemple via un contexte ou une API)
  const idClient = 1; // Remplacez cette valeur par l'identifiant utilisateur réel

  const validateForm = () => {
    const newErrors = {};
    if (!descriptionBesoin.trim()) newErrors.descriptionBesoin = 'La description du besoin est requise.';
    if (!localite.trim()) newErrors.localite = 'La localité est requise.';
    if (!nomCompagnie.trim()) newErrors.nomCompagnie = 'Le nom de la compagnie est requis.';
    
    // Validation email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!adresseEmail.trim()) {
      newErrors.adresseEmail = 'L\'adresse email est requise.';
    } else if (!emailRegex.test(adresseEmail)) {
      newErrors.adresseEmail = 'Veuillez entrer une adresse email valide.';
    }

    // Validation numéro de téléphone (exemple pour un format de téléphone)
    const phoneRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    if (!numeroTel.trim()) {
      newErrors.numeroTel = 'Le numéro de téléphone est requis.';
    } else if (!phoneRegex.test(numeroTel)) {
      newErrors.numeroTel = 'Veuillez entrer un numéro de téléphone valide.';
    }

    // Validation des images (optionnel, max 4 images)
    if (images.length > 4) {
      newErrors.images = 'Vous ne pouvez pas télécharger plus de 4 images.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    
    // Filtrer les fichiers (taille max, type)
    const validFiles = files.filter(file => {
      // Vérifier le type de fichier (images seulement)
      const isImage = file.type.startsWith('image/');
      // Vérifier la taille (max 5 Mo par image)
      const isValidSize = file.size <= 5 * 1024 * 1024;
      
      return isImage && isValidSize;
    });

    // Limiter à 4 images maximum
    const limitedFiles = validFiles.slice(0, 4);
    
    setImages(limitedFiles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Réinitialiser les messages
    setSuccessMessage('');
    setErrors({});

    // Validation du formulaire
    if (!validateForm()) return;

    // Commencer le chargement
    setIsLoading(true);

    // Préparer FormData
    const formData = new FormData();
    formData.append('id_client', idClient);  // Ajout de id_client
    formData.append('description_besoin', descriptionBesoin);
    formData.append('localite', localite);
    formData.append('nom_compagnie', nomCompagnie);
    formData.append('adresse_email', adresseEmail);
    formData.append('numero_tel', numeroTel);
    formData.append('status_demande', 'En attente');

    // Ajouter les fichiers réels au FormData
    images.forEach((file) => {
      formData.append('images', file);
    });

    try {
      const response = await fetch('http://localhost:3000/demandeslogiciels', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();
        
        // Message de succès
        setSuccessMessage(`Demande de logiciel ajoutée avec succès ! 
          ID de la demande : ${result.id}, 
          Nombre d'images : ${result.images_count}`);
        
        // Réinitialiser tous les champs
        resetForm();
      } else {
        // Gestion des erreurs du serveur
        const errorData = await response.json();
        throw new Error(errorData.error || 'Erreur lors de l\'ajout de la demande');
      }
    } catch (error) {
      console.error('Erreur :', error);
      setErrors(prev => ({
        ...prev, 
        submit: error.message || 'Une erreur est survenue lors de l\'envoi du formulaire'
      }));
    } finally {
      // Arrêter le chargement
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setDescriptionBesoin('');
    setLocalite('');
    setNomCompagnie('');
    setAdresseEmail('');
    setNumeroTel('');
    setImages([]); // Vider les images
    setErrors({});
  };

  return (
    <div className="container mt-5">
      <h1 className="text-center mb-4">Ajouter une Demande de Logiciel</h1>
      <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
        {/* Champ idClient retiré du formulaire */}

        <div className="mb-3">
          <label htmlFor="descriptionBesoin" className="form-label">Description du Besoin</label>
          <textarea
            className={`form-control ${errors.descriptionBesoin ? 'is-invalid' : ''}`}
            id="descriptionBesoin"
            rows="3"
            value={descriptionBesoin}
            onChange={(e) => setDescriptionBesoin(e.target.value)}
            required
          />
          {errors.descriptionBesoin && <div className="invalid-feedback">{errors.descriptionBesoin}</div>}
        </div>

        <div className="mb-3">
          <label htmlFor="localite" className="form-label">Localité</label>
          <input
            type="text"
            className={`form-control ${errors.localite ? 'is-invalid' : ''}`}
            id="localite"
            value={localite}
            onChange={(e) => setLocalite(e.target.value)}
            required
          />
          {errors.localite && <div className="invalid-feedback">{errors.localite}</div>}
        </div>

        <div className="mb-3">
          <label htmlFor="nomCompagnie" className="form-label">Nom de la Compagnie</label>
          <input
            type="text"
            className={`form-control ${errors.nomCompagnie ? 'is-invalid' : ''}`}
            id="nomCompagnie"
            value={nomCompagnie}
            onChange={(e) => setNomCompagnie(e.target.value)}
            required
          />
          {errors.nomCompagnie && <div className="invalid-feedback">{errors.nomCompagnie}</div>}
        </div>

        <div className="mb-3">
          <label htmlFor="adresseEmail" className="form-label">Adresse Email</label>
          <input
            type="email"
            className={`form-control ${errors.adresseEmail ? 'is-invalid' : ''}`}
            id="adresseEmail"
            value={adresseEmail}
            onChange={(e) => setAdresseEmail(e.target.value)}
            required
          />
          {errors.adresseEmail && <div className="invalid-feedback">{errors.adresseEmail}</div>}
        </div>

        <div className="mb-3">
          <label htmlFor="numeroTel" className="form-label">Numéro de Téléphone</label>
          <input
            type="tel"
            className={`form-control ${errors.numeroTel ? 'is-invalid' : ''}`}
            id="numeroTel"
            value={numeroTel}
            onChange={(e) => setNumeroTel(e.target.value)}
            required
          />
          {errors.numeroTel && <div className="invalid-feedback">{errors.numeroTel}</div>}
        </div>

        <div className="mb-3">
          <label htmlFor="images" className="form-label">Télécharger des Images</label>
          <input
            type="file"
            className={`form-control ${errors.images ? 'is-invalid' : ''}`}
            id="images"
            onChange={handleImageChange}
            accept="image/*"
            multiple
          />
          {errors.images && <div className="invalid-feedback">{errors.images}</div>}
        </div>

        <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
          {isLoading ? 'Envoi en cours...' : 'Ajouter la Demande'}
        </button>
      </form>

      {successMessage && <div className="alert alert-success mt-3">{successMessage}</div>}
      {errors.submit && <div className="alert alert-danger mt-3">{errors.submit}</div>}
    </div>
  );
};

export default AjouterDemandeLogiciel;
